import ErrorPageController from 'components/ErrorPageController';
import React from 'react';

const FallbackRoute = () => {
    return <ErrorPageController type="404" />;
};

export default FallbackRoute;
